import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'

import {
  type RevolugoDesignSystemConfig,
  useConfig,
} from '../composables/use-config.ts'
import {
  PRIME_CONFIG,
  PrimeVue,
  usePrimeVueLocale,
} from '../plugins/primevue.ts'

import type { App } from 'vue'

// eslint-disable-next-line import/no-unassigned-import
import '../assets/css/main.css'

const { initConfig } = useConfig()

export function initRevolugoDesignSystem(
  app: App,
  options?: RevolugoDesignSystemConfig,
) {
  app.directive('tooltip', Tooltip)
  app.use(ConfirmationService)
  app.use(ToastService)
  app.use(PrimeVue, PRIME_CONFIG)

  usePrimeVueLocale(app)

  initConfig(options)
}
